@let state = accessibilitySidebarState(); @let vm = state.viewModel; @let highContrastTranslationKey =
vm.isHighContrastEnabled ? 'accessibility-sidebar.disable-high-contrast' : 'accessibility-sidebar.enable-high-contrast';
@let highContrastTranslation = highContrastTranslationKey | translate; @let tabindex = vm.isOpen ? 0 : -1;

<aside
  class="accessibility-sidebar-wrapper border-round-bottom-left-md flex flex-column fixed w-auto bg-white shadow-4 transition-linear transition-duration-200 z-3"
  appAddAttributes
  [addAttributes]="{
    '.accessibility-sidebar-font-size-button-increase button': { tabindex, 'aria-label': 'a11y.accessibility-sidebar.button.increase-font-size' | translate | hideTranslation },
    '.accessibility-sidebar-font-size-button-decrease button': { tabindex, 'aria-label': 'a11y.accessibility-sidebar.button.decrease-font-size' | translate | hideTranslation }
  }"
  [class.accessibility-sidebar-wrapper--open]="vm.isOpen"
>
  <div
    id="accessibility-sidebar-toggle-button"
    class="border-round-top-left-md border-round-bottom-left-md flex justify-content-center align-items-center bg-white absolute top-0 cursor-pointer shadow-4"
    role="switch"
    tabindex="0"
    [attr.aria-checked]="vm.isOpen"
    [attr.aria-labelledby]="'accessibility-sidebar-heading'"
    (click)="toggleIsOpen($event)"
    (keydown.enter)="toggleIsOpen($event)"
    (keydown.space)="toggleIsOpen($event)"
  >
    <i class="las la-universal-access"></i>
  </div>

  @if ('accessibility-sidebar.heading' | translate | hideTranslation; as accessibilitySidebarHeadingTranslation) {
  <h3 id="accessibility-sidebar-heading" class="section-content-heading text-center m-y-4">
    {{ accessibilitySidebarHeadingTranslation }}
  </h3>
  }

  <div class="accessibility-sidebar-options flex flex-column m-t-4">
    <div
      class="accessibility-sidebar-option border-color-default flex align-items-center cursor-pointer border-bottom-1 p-x-8"
      role="button"
      [attr.tabindex]="tabindex"
      [attr.aria-labelledby]="'accessibility-sidebar-high-contrast-button'"
      (click)="toggleHighContrast($event)"
      (keydown.enter)="toggleHighContrast($event)"
      (keydown.space)="toggleHighContrast($event)"
    >
      <i class="las la-adjust"></i>

      <span id="accessibility-sidebar-high-contrast-button">{{ highContrastTranslation }}</span>
    </div>

    <div class="accessibility-sidebar-option border-color-default flex align-items-center border-bottom-1 p-x-8">
      <i class="las la-text-height"></i>

      <div class="accessibility-sidebar-font-size-percentage flex align-items-center">
        <span>{{'accessibility-sidebar.font-size' | translate}}</span>

        <span class="theme-color">{{ vm.fontSizePercentage }}%</span>
      </div>

      <div class="accessibility-sidebar-font-size-buttons flex flex-wrap justify-content-center">
        <ls-button
          [className]="'accessibility-sidebar-font-size-button-increase'"
          [color]="'info'"
          [icon]="'las la-plus'"
          (onClick)="increaseFontSize($event, vm.fontSizePercentage)"
        />

        <ls-button
          [className]="'accessibility-sidebar-font-size-button-decrease'"
          [color]="'info'"
          [icon]="'las la-minus'"
          (onClick)="decreaseFontSize($event, vm.fontSizePercentage)"
        />
      </div>
    </div>

    <div
      class="accessibility-sidebar-option flex align-items-center p-x-8"
      role="button"
      [attr.tabindex]="tabindex"
      [attr.aria-labelledby]="'accessibility-sidebar-reset-button'"
      (click)="resetState($event, vm.areDefaultSettingsChanged)"
      (keydown.enter)="resetState($event, vm.areDefaultSettingsChanged)"
      (keydown.space)="resetState($event, vm.areDefaultSettingsChanged)"
    >
      <div
        class="accessibility-sidebar-reset-button flex align-items-center"
        [class.cursor-pointer]="vm.areDefaultSettingsChanged"
        [class.accessibility-sidebar-reset-button--disabled]="!vm.areDefaultSettingsChanged"
      >
        <i class="las la-sync"></i>

        <span id="accessibility-sidebar-reset-button">{{ 'accessibility-sidebar.reset' | translate }}</span>
      </div>
    </div>
  </div>
</aside>
